function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill-rule: evenodd;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M394.922,128.516c78.66-1.135,115.736,43.649,130.469,106.25,4.565,19.4,4.259,46.134.781,66.406-1.461,8.516-.119,17.9-2.734,24.609-2.457.085-3.762-.077-4.688-1.562-3.347-6.98,1.041-23.282-.391-32.031-2.149-13.133-4.086-25.9-6.25-37.5l-0.39-18.36c-3.133-19.8-3.158-38.381-16.016-48.047-24.755-18.609-127.219-20.168-164.844-9.765-13.009,3.6-26.718,5.56-33.593,15.234-6.935,9.759-8.164,22.455-10.547,37.109q-0.195,10.546-.391,21.094c-2.24,13.76-4.543,27.829-7.031,42.969v27.344h-2.344c-5.971-2.572-3.856-10.708-5.078-17.969-3.3-19.6-4.6-44.3-.391-64.453,9.27-44.432,32.527-85.119,70.7-100.782,10.616-4.355,22.832-6.626,35.156-8.984Z"
});

var SvgMHairstyleBuzzFrontVector = function SvgMHairstyleBuzzFrontVector(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "m_hairstyle_buzz_vector",
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMHairstyleBuzzFrontVector, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/m_hairstyle_buzz_front_vector.1b7c7ac3.svg";
export { ForwardRef as ReactComponent };